import exclamationModal from "@assets/images/exclamationModal.svg";
import { Container, Grid } from "@material-ui/core";
import DialogConfirmChangeOrder from "@saleor/changeOrderExport/components/DialogConfirmChangeOrder";
import AppHeader from "@saleor/components/AppHeader";
import DialogConfirm from "@saleor/components/DialogConfirm";
import DialogConfirmDelete from "@saleor/components/DialogConfirmDelete";
import DialogConfirmWarning from "@saleor/components/DialogConfirmWarning";
import DialogProcessing from "@saleor/components/DialogProcessing";
import MyTypography from "@saleor/components/MyTypography";
import PageHeader from "@saleor/components/PageHeader";
import { Tab, TabContainer } from "@saleor/components/Tab";
import BottomBarCreateOrChangeNotRefContract, {
  SummaryDetails
} from "@saleor/createOrChangeNotRefContract/components/BottomBar";
import CreateErrorView from "@saleor/createOrChangeNotRefContract/components/CreateErrorView";
import DialogConfirmCancelItem from "@saleor/createOrChangeNotRefContract/components/DialogConfirmCancelItem";
import DialogConfirmCopyOrder from "@saleor/createOrChangeNotRefContract/components/DialogConfirmCopyOrder";
import DialogCreditBlock from "@saleor/createOrChangeNotRefContract/components/DialogCreditBlock";
import DialogCustomerBlock from "@saleor/createOrChangeNotRefContract/components/DialogCustomerBlock";
import DialogPopUp from "@saleor/createOrChangeNotRefContract/components/DialogPopUp";
import DialogSplitSucess from "@saleor/createOrChangeNotRefContract/components/DialogSplitSucess";
import DialogSubmitBlock from "@saleor/createOrChangeNotRefContract/components/DialogSubmitBlock";
import HeaderTabView from "@saleor/createOrChangeNotRefContract/components/HeaderTab";
import useOneTimeFormiks from "@saleor/createOrChangeNotRefContract/components/ModalAddress/useOnetimeFormiks";
import ModalSendMailNotRef from "@saleor/createOrChangeNotRefContract/components/ModalSendMailNotRef";
import SubmitSnackBar from "@saleor/createOrChangeNotRefContract/components/SubmitSnackBar/SubmitSnackBar";
import { getAllowEditMap } from "@saleor/createOrChangeNotRefContract/constants";
import {
  applyAllCheck,
  priceDateCheck,
  resetHeaderFormik,
  resetItemDetailsFormik
} from "@saleor/createOrChangeNotRefContract/helpers";
import useCancelDeleteItem from "@saleor/createOrChangeNotRefContract/hooks/useCancelDeleteItem";
import useCancelOrder from "@saleor/createOrChangeNotRefContract/hooks/useCancelOrder";
import useCPOrder from "@saleor/createOrChangeNotRefContract/hooks/useCPOrder";
import useCreateOrChangeOrderFetch from "@saleor/createOrChangeNotRefContract/hooks/useCreateOrChangeOrderFetch";
import useCustomerCreditStatus from "@saleor/createOrChangeNotRefContract/hooks/useCustomerCreditStatus";
import useDeleteOrder from "@saleor/createOrChangeNotRefContract/hooks/useDeleteOrder";
import useDisable from "@saleor/createOrChangeNotRefContract/hooks/useDisable";
import useNotRefOrderData from "@saleor/createOrChangeNotRefContract/hooks/useNotRefOrderData";
import useSaveAndSubmitOrder from "@saleor/createOrChangeNotRefContract/hooks/useSaveAndSubmitOrder";
import useSelected from "@saleor/createOrChangeNotRefContract/hooks/useSelected";
import useTableLoading from "@saleor/createOrChangeNotRefContract/hooks/useTableLoading";
import useUndoCancellation from "@saleor/createOrChangeNotRefContract/hooks/useUndoCancellation";
import {
  getNotRefChangeOrderUrl,
  getNotRefCreateOrderPath,
  getNotRefCreateOrderUrl,
  getNotRefPreviewOrderPath,
  NotRefOrderQueryParams,
  NotRefOrderSortField
} from "@saleor/createOrChangeNotRefContract/urls";
import {
  getCashSaleState,
  getCashSaleStatusText,
  INIT_EMPTY_ORDERLINE,
  ItemTab
} from "@saleor/createOrChangeNotRefContract/utils";
import useCashSaleForm from "@saleor/createOrder/components/CashSaleForm/useCashSaleForm";
import DialogError from "@saleor/createOrderExport/components/DialogError";
import {
  DistributionChannelType,
  useCancelCipOrderMutation,
  useDeleteAndSyncOrderLineMutation,
  useDownloadOrdersPdfMutation,
  useDuplicateOrderCipMutation,
  useGetArOutstandingQuery,
  useGetSalesDataLazyQuery,
  useShipToUnloadingPointLazyQuery,
  useSoldToHeaderInfoCipLazyQuery
} from "@saleor/graphql";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import { roundDecimal } from "@saleor/utils/number";
import { getSortUrlVariables } from "@saleor/utils/sort";
import cls from "classnames";
import moment from "moment-timezone";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router";
import { LayoutContext } from "src/context/LayoutContext";

import { clearLocalOrderIds } from "../../utils";
import AddEditItemDetailsNotRef, {
  AddEditItemDetailsNotRefRef
} from "../AddEditItemDetailsTab/AddEditItemDetailsNotRef";
import { ContentHeaderTab, ModeUpdate } from "./const";
import useStyles from "./styles";
import { ChangeOrderCSTab, SubmitStatus, typeConfirmDelete } from "./types";
const HeaderTab = Tab(ChangeOrderCSTab.header);
const ItemDetailsTab = Tab(ChangeOrderCSTab.itemDetails);

export interface ICreateOrChangeNotRefContractView {
  orderId: string;
  params: NotRefOrderQueryParams;
  isChangeFlow: boolean;
}

export interface ISubmitState {
  state: SubmitStatus;
  context: any;
}

const ERROR_CREATION_STATES = ["submitted", "timeout"];

const CreateOrChangeNotRefContractView: React.FC<ICreateOrChangeNotRefContractView> = ({
  orderId,
  params,
  isChangeFlow
}) => {
  const [isViewMode, setIsViewMode] = useState(isChangeFlow);

  const navigate = useNavigator();
  const history = useHistory();
  const layoutContext = useContext(LayoutContext);
  const [openSendMail, setOpenSendMail] = useState<boolean>(false);
  const [openCopyOrder, setOpenCopyOrder] = useState<boolean>(false);
  const [showDetails, setShowDetails] = useState<boolean>(isChangeFlow);
  const [openCancelAddNewItem, setOpenCancelAddNewItem] = useState<boolean>(
    false
  );
  const [shouldRefetchSalesData, setShouldRefetchSalesData] = useState<boolean>(
    false
  );
  const [isRefetchingSalesData, setIsRefetchingSalesData] = useState<boolean>(
    false
  );
  const [salesDataloadingCompleted, setSalesDataloadingCompleted] = useState<
    boolean
  >(false);
  const [submitState, setSubmitState] = useState<ISubmitState>({
    state: "idle",
    context: null
  });
  const [orderAmountAfterVat, setOrderAmountAfterVat] = useState<number>(0);
  const [hasCalculatedPrice, setHasCalculatedPrice] = useState<boolean>(false);

  const hasFetchedInitialDataRef = useRef<boolean>(false);
  const hasCheckedParamTypeRef = useRef<boolean>(false);

  const addEditItemDetailsRef = useRef<AddEditItemDetailsNotRefRef>(null);

  const getNotRefOrderUrl = isChangeFlow
    ? getNotRefChangeOrderUrl
    : getNotRefCreateOrderUrl;

  const {
    fetchOrderData,
    shouldRecheckBlock,
    getOrderData,
    isNonReusableOrder,
    refetchInfo,
    setRefetchInfo,
    changeOrderData,
    loadingFetchOrder,
    refetchChangeOrderData,
    syncCipOrder,
    callResetItemDetails,
    setCallResetItemDetails,
    totalItemsOriginal,
    cashSaleStatusData,
    cashSaleStatusError
  } = useCreateOrChangeOrderFetch({
    orderId,
    navigate,
    setShowDetails,
    isChangeFlow,
    state: submitState?.state
  });

  const [
    fetchSalesData,
    { loading: saleOrgLoading }
  ] = useGetSalesDataLazyQuery({
    fetchPolicy: "no-cache",
    onCompleted: data => {
      if (isRefetchingSalesData) {
        formikHeader.setValues({
          ...formikHeader.values,
          distributionChannelCode:
            data?.getSalesData?.distributionChannel[0]?.code ?? "",
          distributionChannelList:
            data?.getSalesData?.distributionChannel ?? [],
          divisionList: data?.getSalesData?.division ?? []
        });
        setIsRefetchingSalesData(false);
      } else if (!orderId) {
        formikHeader.setValues({
          ...formikHeader.values,
          salesOrganizationCode:
            data?.getSalesData?.defaultSalesOrganization?.code ?? "",
          distributionChannelCode:
            data?.getSalesData?.distributionChannel[0]?.code ?? "",
          salesOrganizationList: data?.getSalesData?.salesOrganization ?? [],
          distributionChannelList:
            data?.getSalesData?.distributionChannel ?? [],
          divisionList: data?.getSalesData?.division ?? [],
          defaultOtcSoldToCode:
            data?.getSalesData?.defaultOtcSoldTo?.code || "9999001",
          defaultOtcSoldToText:
            data?.getSalesData?.defaultOtcSoldTo?.displayText ||
            "9999001 - One time customer TCNK",
          poDate: moment(new Date().toDateString()).format("YYYY-MM-DD")
        });
      } else {
        formikHeader.setValues({
          ...formikHeader.values,
          salesOrganizationList: data?.getSalesData?.salesOrganization ?? [],
          distributionChannelList:
            data?.getSalesData?.distributionChannel ?? [],
          divisionList: data?.getSalesData?.division ?? []
        });
      }
      setSalesDataloadingCompleted(true);
    }
  });

  // clear url params on refresh or first render
  useEffect(() => {
    // skip if there is an error creation state, because the page will render the error message
    if (ERROR_CREATION_STATES.includes(params?.type)) {
      return;
    }
    navigate(getNotRefOrderUrl(orderId)(), { replace: true });
  }, []);

  useEffect(() => {
    if (ERROR_CREATION_STATES.includes(params?.type)) {
      return;
    }

    if (orderId && !isChangeFlow) {
      if (!hasFetchedInitialDataRef.current) {
        fetchOrderData({ variables: { orderId } });
      }
    } else if (!isChangeFlow) {
      fetchSalesData({
        variables: {
          saleOrg: null,
          distributionChannelType: DistributionChannelType.DOMESTIC
        }
      });
    }
    hasFetchedInitialDataRef.current = true;
  }, [orderId, isChangeFlow]);

  useEffect(() => {
    if (params?.type === "submitted" && !hasCheckedParamTypeRef.current) {
      layoutContext.setLayoutType("plain");
      setSubmitState({ state: "submitted", context: null });
    } else if (params?.type === "timeout") {
      layoutContext.setLayoutType("plain");
      setSubmitState({ state: "timeout", context: null });
    }
    hasCheckedParamTypeRef.current = true;

    return () => {
      layoutContext.setLayoutType("app");
    };
  }, [params?.type]);

  const intl = useIntl();
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState<ChangeOrderCSTab>(
    ChangeOrderCSTab.header
  );
  const [activeTabHeader, setActiveTabHeader] = useState<ContentHeaderTab>(
    ContentHeaderTab.salesPartner
  );

  const [openModalConfirmCancel, setOpenModalConfirmCancel] = useState<boolean>(
    false
  );
  const handleCancelItem = () => {
    setOpenModalConfirmCancel(true);
  };

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    success: false,
    mode: ""
  });
  const [salesOrg, setSalesOrg] = useState<string>("");
  const [soldTo, setSoldTo] = useState<string>("");
  const [currentAction, setCurrentAction] = useState<
    "none" | "add" | "split" | "edit"
  >("none");
  const changeCurrentAction = (action: "none" | "add" | "split" | "edit") => {
    if (action !== "none") {
      setIsViewMode(false);
    } else {
      setIsViewMode(true);
    }
    setCurrentAction(action);
  };
  const resetSubmitState = () =>
    setSubmitState({ state: "idle", context: null });

  const orderData = isNonReusableOrder ? undefined : getOrderData?.getOrderData;
  const {
    formikHeader,
    formikItemDetails,
    formikCPItemDetails
  } = useNotRefOrderData(
    orderData,
    changeOrderData?.orderViewData,
    isChangeFlow,
    currentAction
  );

  const {
    isCashSaleOrder,
    isCashSaleAvailableForStatus,
    isEditableCashSale,
    disabledActionForCashSale
  } = getCashSaleState({
    isChangeFlow,
    orderType: formikHeader?.values?.orderType,
    orderStatus: formikHeader?.values?.orderStatus,
    cashSaleStatusData
  });

  const { formikOneTimeSoldTo } = useOneTimeFormiks({}, true);
  const { selected, onSelect, onSelectAll, setSelected } = useSelected(
    formikItemDetails.values.lines,
    isChangeFlow
  );

  const arOutstandingResult = useGetArOutstandingQuery({
    fetchPolicy: "no-cache",
    variables: {
      input: {
        saleOrgCode: formikHeader?.values?.salesOrganizationCode,
        soldToCode: formikHeader?.values?.soldToCode
      }
    },
    skip:
      !isCashSaleOrder ||
      (isChangeFlow && !isCashSaleAvailableForStatus) ||
      !formikHeader?.values?.salesOrganizationCode ||
      !formikHeader?.values?.soldToCode
  });

  const cashSaleFormProps = useCashSaleForm({
    isEditable: !isViewMode && isEditableCashSale,
    orderAmount: roundDecimal(orderAmountAfterVat, 2),
    arOutstandingResult,
    cashSaleData: changeOrderData?.orderViewData?.cashSale
  });

  useEffect(() => {
    if (!isCashSaleOrder) {
      cashSaleFormProps.resetForm();
    }
  }, [isCashSaleOrder]);

  const [
    headerDataRefetch,
    { loading: headerInfoLoading }
  ] = useSoldToHeaderInfoCipLazyQuery({
    fetchPolicy: "no-cache",
    onCompleted: data => {
      const headerData = data?.soldToHeaderInfoCip;
      const salesGroup =
        headerData?.saleGroup.map(({ __typename, ...rest }) => rest) ?? [];
      if (isChangeFlow) {
        const salesGroupCode = changeOrderData?.orderViewData?.salesGroupCode;
        const saleGroupName = changeOrderData?.orderViewData?.salesGroupName;
        if (!salesGroup.find(item => item.code === salesGroupCode)) {
          const newSaleGroup = {
            id: "",
            name: saleGroupName,
            code: salesGroupCode
          };
          salesGroup.push(newSaleGroup);
        }
      }
      formikHeader.setValues(prev => ({
        ...prev,
        shipTolist: headerData?.shipTo ?? [],
        billTolist: headerData?.billTo ?? [],
        paymentTermList: headerData?.paymentTerm ?? [],
        salesGroupList: salesGroup
      }));
    }
  });

  const [
    fetchUnloadingPoints,
    { loading: unloadingPointInfoLoading }
  ] = useShipToUnloadingPointLazyQuery({
    fetchPolicy: "no-cache",
    onCompleted: data => {
      formikHeader.setValues(prev => ({
        ...prev,
        unloadingPoints: data?.shipToUnloadingPoint?.unloadingPoints ?? []
      }));
    }
  });

  const [deleteAndSyncOrderLine] = useDeleteAndSyncOrderLineMutation({
    fetchPolicy: "no-cache"
  });
  const handleCancelAddNewItem = () => {
    deleteAndSyncOrderLine({
      variables: {
        soNo: orderId
      }
    });
    const newListOrderLine = formikItemDetails?.values?.lines.filter(
      line => !line?.isNewItem
    );
    newListOrderLine.sort(
      (itemA: any, itemB: any) => itemA.itemNo - itemB.itemNo
    );
    formikItemDetails.setFieldValue("lines", newListOrderLine);
    navigate(
      getNotRefOrderUrl(orderId)({
        ...getSortUrlVariables(null, params)
      }),
      {
        replace: true
      }
    );
    setOpenCancelAddNewItem(false);
  };
  const closeSnackbar = () => {
    setSnackbarState(prev => ({ ...prev, open: false }));
  };
  const isDescItemNo =
    params.sort === NotRefOrderSortField.itemNo && !params.asc;

  const goToPreview = () => {
    navigate(getNotRefPreviewOrderPath(orderId));
  };
  const clearSelected = () => setSelected([]);
  const { confirmCancelItem, loadingCancelDeleteItem } = useCancelDeleteItem({
    formikItemDetails,
    orderId,
    selected,
    setOpenModalConfirmCancel,
    clearSelected,
    refetchChangeOrderData,
    setSubmitState,
    totalItemsOriginal
  });
  const handleRefetch = (v: boolean) => {
    setRefetchInfo({
      refetch: v,
      soldTo: "",
      saleOrg: "",
      distributionChannel: "",
      division: "",
      shipTo: ""
    });
  };
  const handleSalesOrg = data => {
    setSalesOrg(data);
  };

  const onEdit = async () => {
    const res = await callCustomerCreditBlock();
    if (!res) {
      syncCipOrder(formikHeader, formikItemDetails).then(res => {
        if (res) {
          setIsViewMode(false);
        }
      });
    }
  };

  const onCancelOrder = async () => {
    const res = await callCustomerCreditBlock();
    if (!res) {
      syncCipOrder(formikHeader, formikItemDetails).then(res => {
        if (res) {
          handleCancelOrder();
        }
      });
    }
  };

  const onCancelEdit = () => {
    resetItemDetailsFormik(formikItemDetails, params.asc);
    resetHeaderFormik(formikHeader);
    cashSaleFormProps.resetForm();
    setHasCalculatedPrice(false);
    changeCurrentAction("none");
  };
  const handleSoldTo = data => {
    setSoldTo(data);
  };

  const handleShowItemDetailsTab = data => {
    setShowDetails(data);
  };

  const {
    toggleModalCreditBlock,
    toggleModalCustomerBlock,
    openModalCustomerBlock,
    openModalCreditBlock,
    callCustomerCreditBlock
  } = useCustomerCreditStatus(formikHeader);

  const [openChangeOrderAdd, setOpenChangeOrderAdd] = useState(false);
  const [isNewItemAdded, setIsNewItemAdded] = useState<boolean>(false);
  const [openDialogSplitSucess, setOpenDialogSplitSucess] = useState<boolean>(
    false
  );
  const renderStatus = (item: string) => (
    <div className={classes.flex}>
      <div
        className={classes.statusIcon}
        style={{ backgroundColor: EStatusType[item] }}
      ></div>
      <MyTypography
        variant="body3"
        className={cls(classes.alignRight, {
          [classes.textRed]:
            formikHeader.values?.orderStatus === "Cancelled (93)"
        })}
      >
        {item}
      </MyTypography>
    </div>
  );

  useEffect(() => {
    if (isChangeFlow) {
      const isNewItemPresent = formikItemDetails?.values?.lines?.some(
        item => item?.isNewItem === true
      );
      if (isNewItemAdded) {
        if (!isNewItemPresent) {
          setIsNewItemAdded(false);
          changeCurrentAction("none");
        }
      } else {
        if (isNewItemPresent) {
          changeCurrentAction("add");
          setIsNewItemAdded(true);
        }
      }
    }
  }, [formikItemDetails?.values?.lines?.length]);

  const addProduct = async () => {
    if (isChangeFlow) {
      const res = await callCustomerCreditBlock();
      if (!res) {
        syncCipOrder(formikHeader, formikItemDetails).then(res => {
          if (res) {
            setOpenChangeOrderAdd(true);
          }
        });
      }
    } else {
      const newItemCount = formikItemDetails.values.lines.length + 1;
      const newItem = INIT_EMPTY_ORDERLINE((newItemCount * 10).toString());
      const updatedLines = params.asc
        ? [...formikItemDetails.values.lines, newItem]
        : [newItem, ...formikItemDetails.values.lines];
      formikItemDetails.setFieldValue("lines", updatedLines);
    }
  };

  const { tableLoading, setTableLoading } = useTableLoading();

  const {
    deleteOrderLines,
    handleOpenDelete,
    openDelete,
    closeDeletePopup,
    deleteChangeOrderLines
  } = useDeleteOrder({
    formikItemDetails,
    selected,
    isDescItemNo,
    clearSelected,
    isChangeFlow,
    setTableLoading,
    setSubmitState,
    totalItemsOriginal
  });

  const [openModalConfirmDelete, setOpenModalConfirmDelete] = useState<boolean>(
    false
  );
  const { handleCancelOrder, dataModalConfirmDelete } = useCancelOrder({
    setOpenModalConfirmDelete
  });

  const [cancelDeleteItem] = useCancelCipOrderMutation({
    variables: {
      soNo: orderId
    }
  });

  const { handleCPResultDateConfirm, handleSubmitResponse } = useCPOrder({
    formikCPItemDetails,
    setSubmitState,
    resetSubmitState,
    formikHeader,
    navigate,
    isChangeFlow,
    currentAction,
    formikItemDetails,
    formikCashSale: cashSaleFormProps.formik,
    isCashSaleOrder,
    isEditableCashSale,
    orderId,
    refetchChangeOrderData,
    setOpenDialogSplitSucess,
    changeCurrentAction,
    params
  });
  const {
    saveDraft,
    createPreDraft,
    onSubmitCancel,
    validateBeforeSubmitOrder,
    submitOrder,
    validateBeforeSaveChangOrder,
    saveChangOrder,
    validateBeforeSaveAddNewCipProduct,
    saveAddNewCipProduct
  } = useSaveAndSubmitOrder({
    formikHeader,
    formikItemDetails,
    formikCashSale: cashSaleFormProps.formik,
    handleSubmitResponse,
    ModeUpdate,
    navigate,
    orderId,
    resetSubmitState,
    setSnackbarState,
    setSubmitState,
    currentAction,
    totalItemsOriginal,
    orderAmountAfterVat,
    hasCalculatedPrice,
    isCashSaleOrder,
    isEditableCashSale
  });

  const {
    isDisableAddButton,
    isDisableDeleteButton,
    isDisableCancelItemButton,
    isDisablePriceCalcButton,
    isDisableCancelOrderButton
  } = useDisable({
    isChangeFlow,
    isDescItemNo,
    formikHeader,
    formikItemDetails,
    disabledActionForCashSale
  });

  const [tabLoading, setTabLoading] = useState<boolean>(false);

  const onTabClick = (tab, onCompleted?: () => void) => {
    if (!orderId && tab === ChangeOrderCSTab.itemDetails) {
      if (tabLoading) {
        return;
      }
      setTabLoading(true);
      createPreDraft()
        .then(res => {
          if (res) {
            setActiveTab(tab);
            onCompleted?.();
          }
        })
        .finally(() => setTabLoading(false));
    } else {
      setActiveTab(tab);
      onCompleted?.();
    }
  };

  const launchSendEmail = async () => {
    const res = await callCustomerCreditBlock();
    if (!res) {
      setOpenSendMail(true);
    }
  };

  const [
    downloadPdf,
    { loading: loadingDownloadPdf }
  ] = useDownloadOrdersPdfMutation({
    variables: {
      soNo: orderId
    },
    onCompleted: data => {
      const resultPDF = data?.downloadOrdersPdf?.exportedFileBase64;
      if (resultPDF) {
        const linkSource = `data:application/pdf;base64,${resultPDF}`;
        const downloadLink = document.createElement("a");
        const fileName = data?.downloadOrdersPdf?.fileName;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
    }
  });

  const notify = useNotifier();

  const handleConfirmCancelOrder = () => {
    setSubmitState({ state: "processing", context: null });
    switch (dataModalConfirmDelete.typeConfirm) {
      case typeConfirmDelete.cancelOrder:
        cancelDeleteItem({
          variables: {
            soNo: orderId
          }
        }).then(({ data }) => {
          if (data?.cancelCipOrder?.status) {
            refetchChangeOrderData();
            setActiveTab(ChangeOrderCSTab.itemDetails);
            clearSelected();
            resetSubmitState();
          } else {
            resetSubmitState();
            const { sapOrderMessages, sapItemMessages } = data.cancelCipOrder;
            if (sapOrderMessages?.length || sapItemMessages?.length) {
              setSubmitState({
                state: "errorPopup",
                context: data.cancelCipOrder
              });
            } else {
              const errors = data?.cancelCipOrder?.errors;
              if (errors.length > 0) {
                notify({
                  status: "error",
                  title: "Something went wrong",
                  text: errors.map(
                    ({ code, message }) => `${code || ""} - ${message}`
                  )
                });
              }
            }
          }
        });
        break;
    }
    setOpenModalConfirmDelete(false);
  };

  const [
    duplicateOrder,
    { loading: loadingDuplicate }
  ] = useDuplicateOrderCipMutation({
    variables: {
      soNo: orderId
    },
    onCompleted: data => {
      if (data?.duplicateOrderCip?.order?.id) {
        setCurrentAction("none");
        setIsViewMode(false);
        navigate(getNotRefCreateOrderPath(data?.duplicateOrderCip?.order?.id));
      }
    }
  });
  const handleDuplicateOrder = async () => {
    const res = await callCustomerCreditBlock();
    if (!res) {
      setOpenCopyOrder(true);
    }
  };

  useEffect(() => {
    if (refetchInfo?.refetch && refetchInfo?.soldTo) {
      headerDataRefetch({
        variables: {
          soldTo: refetchInfo?.soldTo,
          saleOrg: refetchInfo?.saleOrg,
          distributionChannel: refetchInfo?.distributionChannel,
          division: refetchInfo?.division
        }
      });
      fetchSalesData({
        variables: {
          saleOrg: refetchInfo?.saleOrg,
          distributionChannelType: DistributionChannelType.DOMESTIC
        }
      });
      fetchUnloadingPoints({
        variables: {
          shipTo: refetchInfo?.shipTo
        }
      });
      handleRefetch(false);
    }
  }, [refetchInfo?.refetch]);

  useEffect(() => {
    const salesOrgCode = formikHeader?.values?.salesOrganizationCode ?? "";
    if (salesOrgCode === "") {
      return;
    }
    if (shouldRefetchSalesData) {
      setIsRefetchingSalesData(true);
      fetchSalesData({
        variables: {
          saleOrg: salesOrgCode,
          distributionChannelType: DistributionChannelType.DOMESTIC
        }
      });
    } else {
      setShouldRefetchSalesData(true);
    }
  }, [formikHeader?.values?.salesOrganizationCode]);

  const [oldState, setOldState] = useState({
    requestDate: null,
    priceDate: null
  });
  useEffect(() => {
    if (
      activeTab === ChangeOrderCSTab.itemDetails &&
      (oldState.requestDate !== formikHeader.values?.requestDate ||
        oldState.priceDate !== formikHeader.values?.requestDate)
    ) {
      formikItemDetails.setValues(prev => ({
        ...prev,
        lines: prev.lines.map(l => ({
          ...l,
          ...(!l?.requestDate &&
          oldState.requestDate !== formikHeader.values?.requestDate
            ? { requestDate: formikHeader.values?.requestDate }
            : {})
        }))
      }));
      setOldState(prev => ({
        ...prev,
        requestDate: formikHeader.values?.requestDate
      }));
    }
  }, [activeTab]);

  function canUpdatePriceDate(l) {
    return (
      (!l?.priceDate || oldState.priceDate === l.priceDate) &&
      !priceDateCheck("priceDate", isChangeFlow, l) &&
      !getAllowEditMap(
        formikHeader?.values?.orderType === "ZP20",
        "priceDate"
      ).has(l.itemStatusEn)
    );
  }

  useEffect(() => {
    if (oldState.priceDate !== formikHeader.values?.requestDate) {
      formikItemDetails.setValues(prev => ({
        ...prev,
        lines: prev.lines.map(l => ({
          ...l,
          ...(canUpdatePriceDate(l)
            ? { priceDate: formikHeader.values?.requestDate }
            : {})
        }))
      }));
      setOldState(prev => ({
        ...prev,
        priceDate: formikHeader.values?.requestDate
      }));
    }
  }, [formikHeader.values?.requestDate]);

  const handleApplyAllRequestDate = () => {
    const { requestDate, orderType } = formikHeader.values;
    if (requestDate) {
      const callApplyAllCheck = (line, name) =>
        applyAllCheck(
          requestDate,
          name,
          orderType === "ZP20",
          currentAction,
          line,
          isChangeFlow
        );
      formikItemDetails.setValues(prev => ({
        currentIndex: -1,
        isSplitSubmit: false,
        lines: prev.lines.map(v => ({
          ...v,
          requestDate: callApplyAllCheck(v, "requestDate"),
          priceDate: callApplyAllCheck(v, "priceDate")
        }))
      }));
      setSnackbarState({
        open: true,
        success: true,
        mode: ModeUpdate.ApplyAll
      });
    }
  };
  const getTitle = () => {
    if (isChangeFlow && currentAction === "add") {
      return intl.formatMessage({ defaultMessage: "Add new items" });
    } else if (isChangeFlow && !isViewMode) {
      return intl.formatMessage({ defaultMessage: "Edit Order" });
    } else if (isChangeFlow) {
      return intl.formatMessage({ defaultMessage: "Order Details" });
    }
  };
  const loadingAll = useMemo(
    () => loadingDownloadPdf || loadingDuplicate || tableLoading,
    [loadingDownloadPdf, loadingDuplicate, tableLoading]
  );

  useEffect(() => {
    if (formikHeader.values?.callPreDraft && !orderId) {
      createPreDraft();
    }
  }, [formikHeader.values?.callPreDraft]);

  function undoCancelOrderLine(item_no) {
    const undoCancelContext = {
      title: "ดึง Order item นี้กลับ",
      content:
        "กรุณากด “ยืนยัน” เพื่อดำเนินการต่อ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้",
      onOk: () => confirmUndoCancel(item_no),
      onClose: resetSubmitState
    };
    setSubmitState({ state: "undoCancelPopup", context: undoCancelContext });
  }
  const { confirmUndoCancel } = useUndoCancellation({
    orderId,
    resetSubmitState,
    refetchChangeOrderData,
    setSubmitState,
    totalItemsOriginal
  });

  const shouldShowCashSaleWarningBeforeSave = () =>
    isCashSaleOrder &&
    !cashSaleFormProps.formik?.values?.cashFlag &&
    !cashSaleFormProps.formik?.values?.balanceFlag;

  const onSubmitOrder = async () => {
    const hasNoPriceInSap = formikItemDetails?.values?.lines?.some(
      item => item?.priceStatus === "E" && item?.materialType !== "85"
    );
    if (hasNoPriceInSap) {
      setSubmitState({ state: "noPriceInSapPopup", context: null });
      return;
    }

    let title = isChangeFlow ? "บันทึกคำสั่งซื้อ" : "ยืนยันตกลงสั่งซื้อ";
    let content = isChangeFlow
      ? "กรุณากด “ยืนยัน” เพื่อบันทึกคำสั่งซื้อ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้"
      : "กรุณากด “ยืนยัน” เพื่อสร้างคำสั่งซื้อ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้";

    if (shouldShowCashSaleWarningBeforeSave()) {
      title = "คุณยังไม่ได้ระบุ “จำนวนเงินโอน” หรือ “เงินเหลือที่ต้องการใช้”";
      content =
        "คุณสามารถกด “ยืนยัน” เพื่อสร้างคำสั่งซื้อ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้";
    }

    const submitContext = {
      title,
      content,
      onClose: () => {
        onSubmitCancel();
        if (shouldShowCashSaleWarningBeforeSave()) {
          changeToCashSaleTab();
        }
      }
    };

    // Create order
    if (!isChangeFlow) {
      const isValid = await validateBeforeSubmitOrder();
      if (!isValid) {
        return;
      }
      setSubmitState({
        state: "confirmPopup",
        context: { ...submitContext, onOk: submitOrder }
      });
      return;
    }

    if (currentAction === "none" || currentAction === "edit") {
      // Change order
      const isValid = await validateBeforeSaveChangOrder();
      if (!isValid) {
        return;
      }
      setSubmitState({
        state: "confirmPopup",
        context: { ...submitContext, onOk: saveChangOrder }
      });
      return;
    } else {
      // Add new CIP product
      const isValid = await validateBeforeSaveAddNewCipProduct();
      if (!isValid) {
        return;
      }
      setSubmitState({
        state: "confirmPopup",
        context: { ...submitContext, onOk: saveAddNewCipProduct }
      });
      return;
    }
  };

  const changeToCashSaleTab = () => {
    cashSaleFormProps.preventCashAmountAutoFillOnNextMount();
    onTabClick(ChangeOrderCSTab.itemDetails, () =>
      setTimeout(() =>
        addEditItemDetailsRef?.current?.forceChangeTab(ItemTab.tabD)
      )
    );
  };

  const titlefields = [
    "name1",
    "street1",
    "street2",
    "subDistrict",
    "district",
    "city",
    "postalCode"
  ];

  enum EStatusType {
    "Received Order" = "#A3AED0",
    "Credit/Cash Issue" = "#FFC107",
    "Partial Committed Order" = "#3860BE",
    "Ready for delivery" = "#007BFF",
    "Partial Delivery" = "#009FB8",
    "Completed Delivery" = "#6CC04A",
    "Cancelled (93)" = "#E41B17",
    "Completed Order" = "#1E7D34"
  }
  const check = c => (c === "name1" ? "" : " ");
  const getAddressFormat = otc =>
    titlefields.reduce((p, c) => p + (otc?.[c] ? check(c) + otc[c] : ""), "");

  useEffect(() => {
    setIsViewMode(isChangeFlow);
    setActiveTab(ChangeOrderCSTab.header);
    setSoldTo("");
  }, [isChangeFlow]);

  useEffect(() => {
    if (callResetItemDetails) {
      resetItemDetailsFormik(formikItemDetails, params.asc);
      setCallResetItemDetails(false);
    }
  }, [callResetItemDetails]);

  const handleBack = () => {
    const submitContext = {
      title: "ยกเลิกการแก้ไขคำสั่งซื้อ",
      content:
        "กรุณากด “ยืนยัน” เพื่อยกเลิกการแก้ไขคำสั่งซื้อ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้",
      onOk: handleConfirmBack,
      onClose: resetSubmitState
    };
    setSubmitState({ state: "confirmBackPopup", context: submitContext });
  };

  const handleConfirmBack = () => {
    history.goBack();
  };

  const handleRefetchOrderData = () => {
    refetchChangeOrderData();
  };

  const handleOrderSummaryDetailsComplete = (values: SummaryDetails) => {
    setOrderAmountAfterVat(values?.orderAmountAfterVat);
  };

  const handleCalculatedPriceComplete = () => {
    setHasCalculatedPrice(true);
  };

  if (ERROR_CREATION_STATES.includes(submitState.state)) {
    return (
      <CreateErrorView
        onConfirm={() => {
          clearLocalOrderIds();
          navigate("/");
        }}
        topicText={submitState.state === "submitted" ? "ผิดพลาด" : "หมดเวลา"}
      />
    );
  }

  return (
    <Container className={classes.container}>
      {isChangeFlow && (
        <>
          <MyTypography variant={"subtitle3"}>
            {intl.formatMessage({
              defaultMessage: "Change Order",
              description: "subtitle"
            })}
          </MyTypography>

          <PageHeader className={classes.pageHeader} title={getTitle()} />

          <AppHeader onBack={handleBack}>
            <MyTypography variant="body3">
              {intl.formatMessage({ defaultMessage: "กลับไป" })}
            </MyTypography>
          </AppHeader>
        </>
      )}

      {!isChangeFlow && (
        <PageHeader
          className={classes.pageHeader}
          title="Create Order Packaging"
        />
      )}
      <TabContainer>
        <div className={classes.tabBox}>
          {!["add", "split"].includes(currentAction) && (
            <HeaderTab
              testId="header-tab"
              isActive={activeTab === ChangeOrderCSTab.header}
              changeTab={onTabClick}
            >
              <MyTypography variant="h6" className={classes.tab}>
                {intl.formatMessage({
                  defaultMessage: "Header",
                  description: "subtitle"
                })}
              </MyTypography>
            </HeaderTab>
          )}
          {showDetails && (
            <ItemDetailsTab
              testId="item-details-tab"
              isActive={activeTab === ChangeOrderCSTab.itemDetails}
              changeTab={onTabClick}
            >
              <MyTypography variant="h6" className={classes.tab}>
                {intl.formatMessage({
                  defaultMessage: "Item Details",
                  description: "subtitle"
                })}
              </MyTypography>
            </ItemDetailsTab>
          )}
        </div>
      </TabContainer>

      <Grid
        container
        spacing={2}
        className={classes.boxInfo}
        data-testid="order-info"
      >
        <Grid item xs={12} md={5}>
          <Grid container spacing={2}>
            {isChangeFlow && (
              <>
                <Grid item md={2}>
                  <MyTypography variant={"subtitle3"}>S/O No.</MyTypography>
                </Grid>
                <Grid item md={10}>
                  <MyTypography variant={"body3"} data-testid="orderId">
                    {orderId}
                  </MyTypography>
                </Grid>
              </>
            )}
            <Grid item md={2}>
              <MyTypography variant={"subtitle3"}>Sales Org</MyTypography>
            </Grid>
            <Grid item md={10}>
              <MyTypography variant={"body3"} data-testid="salesOrg">
                {salesOrg}
              </MyTypography>
            </Grid>
            {formikHeader?.values?.isOneTimeCustomer ? (
              <>
                <Grid item md={2}>
                  <MyTypography variant={"subtitle3"}>Cust.Code</MyTypography>
                </Grid>
                <Grid item md={10}>
                  <MyTypography variant={"body3"} data-testid="customerCode">
                    {formikHeader?.values?.soldToDisplayText || "-"}
                  </MyTypography>
                </Grid>
              </>
            ) : (
              <>
                <Grid item md={2}>
                  <MyTypography variant={"subtitle3"}>
                    Sold-to Party
                  </MyTypography>
                </Grid>
                <Grid item md={10}>
                  <MyTypography variant={"body3"} data-testid="soldToParty">
                    {soldTo || formikHeader?.values?.soldToDisplayText || "-"}
                  </MyTypography>
                </Grid>
              </>
            )}
            {formikHeader?.values?.isOneTimeCustomer && (
              <>
                <Grid item md={2}>
                  <MyTypography variant={"subtitle3"}>Cust.Name</MyTypography>
                </Grid>
                <Grid item md={10}>
                  <MyTypography variant={"body3"} data-testid="customerName">
                    {formikHeader?.values?.customerName}
                  </MyTypography>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} md={5}>
          <Grid container spacing={2}>
            {isChangeFlow && (
              <>
                <Grid item md={3}>
                  <MyTypography variant={"subtitle3"}>PO No.</MyTypography>
                </Grid>
                <Grid item md={9}>
                  <MyTypography variant={"body3"} data-testid="poNo">
                    {formikHeader.values?.poNumber}
                  </MyTypography>
                </Grid>
              </>
            )}
            <Grid item md={3}>
              <MyTypography variant={"subtitle3"}>Bill-to Party</MyTypography>
            </Grid>
            <Grid item md={9}>
              <MyTypography variant={"body3"} data-testid="billToParty">
                {(formikHeader?.values?.isOneTimeCustomer
                  ? getAddressFormat(formikHeader.values?.otcBillTo)
                  : formikHeader.values?.billTo) || "-"}
              </MyTypography>
            </Grid>
            <Grid item md={3}>
              <MyTypography variant={"subtitle3"}>Ship-to Party</MyTypography>
            </Grid>
            <Grid item md={9}>
              <MyTypography variant={"body3"} data-testid="shipToParty">
                {(formikHeader?.values?.isOneTimeCustomer
                  ? formikHeader.values?.shipTo
                    ? formikHeader.values?.shipTo
                    : getAddressFormat(formikHeader.values?.otcShipTo)
                  : formikHeader.values?.shipTo) || "-"}
              </MyTypography>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} md={2}>
          <Grid
            container
            style={{
              justifyContent: "end",
              paddingRight: "8px"
            }}
          >
            <Grid
              item
              container
              style={{ flexDirection: "column", gap: 16, width: "auto" }}
            >
              {isChangeFlow && (
                <div>
                  <MyTypography variant="subtitle3" gutterBottom>
                    eOrdering Status
                  </MyTypography>
                  <MyTypography variant="body3" data-testid="orderStatus">
                    {formikHeader.values?.orderStatus
                      ? renderStatus(formikHeader.values?.orderStatus)
                      : ""}
                  </MyTypography>
                </div>
              )}

              {isChangeFlow && isCashSaleOrder && (
                <div>
                  <MyTypography variant="subtitle3" gutterBottom>
                    Cash Sale Status
                  </MyTypography>
                  <MyTypography
                    variant="body3"
                    data-testid="cashSaleStatus"
                    className={cls({
                      [classes.cashSaleStatusError]:
                        (cashSaleStatusData?.getCashSaleStatus &&
                          !cashSaleStatusData?.getCashSaleStatus?.status) ||
                        !!cashSaleStatusError
                    })}
                  >
                    {getCashSaleStatusText(
                      cashSaleStatusData?.getCashSaleStatus?.statusName,
                      !!cashSaleStatusError
                    ) || "-"}
                  </MyTypography>
                </div>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <div hidden={activeTab !== ChangeOrderCSTab.header}>
        <HeaderTabView
          activeTab={activeTabHeader}
          setActiveTab={setActiveTabHeader}
          formik={formikHeader}
          showDetails={showDetails}
          handleShowItemDetailsTab={handleShowItemDetailsTab}
          handleSalesOrg={handleSalesOrg}
          handleSoldTo={handleSoldTo}
          fetchOrderData={fetchOrderData}
          shouldRecheckBlock={shouldRecheckBlock}
          orderId={orderId}
          formikOneTimeCust={formikOneTimeSoldTo}
          formikItemDetails={formikItemDetails}
          onApplyAll={handleApplyAllRequestDate}
          isChangeFlow={isChangeFlow}
          isViewMode={isViewMode}
          saleOrgLoading={saleOrgLoading}
          salesDataloadingCompleted={salesDataloadingCompleted}
        />
      </div>
      <div>
        {activeTab === ChangeOrderCSTab.itemDetails && (
          <AddEditItemDetailsNotRef
            ref={addEditItemDetailsRef}
            formik={formikItemDetails}
            params={params}
            selected={selected}
            onSelect={onSelect}
            onSelectAll={onSelectAll}
            orderId={orderId}
            formikHeader={formikHeader}
            isChangeFlow={isChangeFlow}
            isViewMode={isViewMode}
            openChangeOrderAdd={openChangeOrderAdd}
            setOpenChangeOrderAdd={setOpenChangeOrderAdd}
            deleteChangeOrderLines={deleteChangeOrderLines}
            currentAction={currentAction}
            changeCurrentAction={changeCurrentAction}
            isNewItemAdded={isNewItemAdded}
            setSubmitState={setSubmitState}
            resetSubmitState={resetSubmitState}
            handleSubmitResponse={handleSubmitResponse}
            undoCancelOrderLine={undoCancelOrderLine}
            setCurrentAction={action => setCurrentAction(action)}
            tableLoading={tableLoading}
            setTableLoading={setTableLoading}
            totalItemsOriginal={totalItemsOriginal}
            disabledActionForCashSale={disabledActionForCashSale}
            cashSaleFormProps={cashSaleFormProps}
          />
        )}
      </div>
      <DialogConfirmDelete
        onConfirm={deleteOrderLines}
        onCancel={closeDeletePopup}
        open={openDelete}
        title={
          <span className={classes.titleDelete}>
            Delete item สินค้าที่เลือก
          </span>
        }
        content={
          <MyTypography variant={"body2"}>
            {intl.formatMessage({
              defaultMessage:
                "กรุณากด “ยืนยัน” เพื่อลบรายการสินค้าที่เลือก หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้"
            })}
          </MyTypography>
        }
      />
      {showDetails && (
        <BottomBarCreateOrChangeNotRefContract
          onSendMail={launchSendEmail}
          onDownloadPdf={downloadPdf}
          onDuplicate={handleDuplicateOrder}
          loading={loadingAll}
          onAddItem={addProduct}
          activeTab={activeTab}
          isViewMode={isViewMode}
          isChangeFlow={isChangeFlow}
          onSaveDraft={saveDraft}
          onPreviewOrderTest={goToPreview}
          onSubmitOrder={onSubmitOrder}
          deleteCount={selected.length}
          onDelete={handleOpenDelete}
          onCancelOrder={onCancelOrder}
          onCancelDeleteItem={handleCancelItem}
          priceData={{
            itemCount: formikItemDetails.values.lines.length,
            orderAmtAfterVat: +formikHeader.values.orderAmtAfterVat,
            orderAmtVat: +formikHeader.values.orderAmtVat,
            orderAmtBeforeVat: +formikHeader.values.orderAmtBeforeVat,
            currency: formikHeader.values.currency,
            taxClass: formikHeader.values.taxClass
          }}
          isDisableBtnSaveDraft={tableLoading}
          isDisableBtnCreateOrder={isDisableDeleteButton() || tableLoading}
          disableAddButton={isDisableAddButton() || tableLoading}
          disableDeleteButton={isDisableDeleteButton() || tableLoading}
          disableCancelItemButton={isDisableCancelItemButton() || tableLoading}
          disablePriceCalcButton={isDisablePriceCalcButton() || tableLoading}
          disableCancelOrderButton={
            isDisableCancelOrderButton() || tableLoading
          }
          formik={formikItemDetails}
          formikHeader={formikHeader}
          orderId={orderId}
          params={params}
          currentAction={currentAction}
          onEdit={onEdit}
          onCancelEdit={onCancelEdit}
          onCancelAddNewItem={() => setOpenCancelAddNewItem(true)}
          status={formikHeader.values?.orderStatus}
          setSubmitState={setSubmitState}
          onSummaryDetailsChangeComplete={handleOrderSummaryDetailsComplete}
          onCalculatedPriceComplete={handleCalculatedPriceComplete}
        />
      )}
      <SubmitSnackBar
        open={snackbarState.open}
        success={snackbarState.success}
        onClose={closeSnackbar}
        mode={snackbarState.mode}
      />

      <DialogSubmitBlock
        testId="noPriceInSapPopup"
        isOpen={submitState.state === "noPriceInSapPopup"}
        onClose={() => resetSubmitState()}
      />

      <DialogSubmitBlock
        testId="noPriceCalculationPopup"
        isOpen={submitState.state === "noPriceCalculationPopup"}
        content="กรุณากด “คำนวณราคา” ก่อนกด ตกสั่งซื้อ"
        okText="ปิดหน้าต่าง"
        onClose={() => resetSubmitState()}
      />

      <DialogConfirmChangeOrder
        title={
          <span
            className={cls(
              submitState?.state !== "confirmBackPopup" && classes.titleMain
            )}
          >
            {submitState?.context?.title}
          </span>
        }
        content={submitState?.context?.content}
        cancelText="กลับไป"
        open={
          (submitState.state === "confirmPopup" && !isChangeFlow) ||
          submitState.state === "undoCancelPopup" ||
          submitState.state === "confirmBackPopup"
        }
        onClose={submitState?.context?.onClose}
        onOk={submitState?.context?.onOk}
      />
      <DialogConfirmCancelItem
        onCancel={() => setOpenModalConfirmCancel(false)}
        onConfirm={confirmCancelItem}
        open={openModalConfirmCancel}
        formikCPItemDetails={formikCPItemDetails}
        formikItemDetails={formikItemDetails}
        formikHeaderDetails={formikHeader}
        selectedOrderLines={selected}
        loading={loadingCancelDeleteItem}
      />
      <DialogConfirm
        titleClass={classes.titleMain}
        title={submitState?.context?.title}
        content={submitState?.context?.content}
        onCancel={submitState?.context?.onClose}
        onConfirm={submitState?.context?.onOk}
        cancelText="กลับไป"
        open={
          submitState.state === "confirmPopup" &&
          isChangeFlow &&
          (currentAction === "add" ||
            currentAction === "none" ||
            currentAction === "edit")
        }
      />
      <DialogConfirmWarning
        onCancel={() => setOpenModalConfirmDelete(false)}
        onConfirm={handleConfirmCancelOrder}
        open={openModalConfirmDelete}
        okText={dataModalConfirmDelete.okText}
        cancelText={dataModalConfirmDelete.cancelText}
        title={dataModalConfirmDelete.title}
        content={dataModalConfirmDelete.content}
      />

      <DialogError
        open={submitState.state === "validationError"}
        onClose={() => {
          setSubmitState(prev => ({ ...prev, state: "idle" }));
          if (submitState.context?.v1) {
            return onTabClick(ChangeOrderCSTab.header);
          }
          if (submitState.context?.v2) {
            return onTabClick(ChangeOrderCSTab.itemDetails, () =>
              setTimeout(() =>
                addEditItemDetailsRef?.current?.forceChangeTab(ItemTab.tabA)
              )
            );
          }
          if (submitState.context?.v3) {
            return changeToCashSaleTab();
          }
        }}
      />
      <DialogPopUp
        open={submitState.state === "errorPopup"}
        errors={submitState.context}
        formikCPItemDetails={formikCPItemDetails}
        onConfirm={handleCPResultDateConfirm}
        formikItemDetails={formikItemDetails}
        currentAction={currentAction}
        onFetchOrderData={handleRefetchOrderData}
      />
      <DialogConfirm
        buttonClass={"defaultB"}
        title={"ยกเลิกเพิ่มรายการสินค้า"}
        content={
          'กรุณากด "ยืนยัน" เพื่อยกเลิกเพิ่มรายการสินค้าทั้งหมด หรือกด "กลับไป" เพื่อปิดหน้าต่างนี้'
        }
        onCancel={() => setOpenCancelAddNewItem(false)}
        onConfirm={handleCancelAddNewItem}
        open={openCancelAddNewItem}
      />
      <DialogProcessing
        open={
          submitState.state === "processing" ||
          loadingCancelDeleteItem ||
          loadingFetchOrder ||
          headerInfoLoading ||
          unloadingPointInfoLoading ||
          (saleOrgLoading && Boolean(orderId))
        }
        title="ระบบกำลังประมวลผลคำสั่งซื้อ"
        description={
          <span style={{ color: "red", fontSize: 14 }}>
            กรุณารอสักครู่ / โปรดอย่ากด Refresh หรือปิดหน้าจอ
          </span>
        }
      />
      <DialogSplitSucess
        isOpen={openDialogSplitSucess}
        title={"Split Item สำเร็จ"}
        buttonText={"ดำเนินการต่อ"}
        onClose={() => setOpenDialogSplitSucess(false)}
      />
      <ModalSendMailNotRef
        soNo={orderId}
        saleOrg={formikHeader?.values?.salesOrganizationCode}
        soldToCode={[formikHeader?.values?.soldToCode]}
        soldToName={formikHeader?.values?.soldToDisplayText}
        // orderId={[orderId]}
        open={openSendMail}
        onClose={() => setOpenSendMail(false)}
      />
      <DialogConfirmCopyOrder
        open={openCopyOrder}
        loading={loadingDuplicate}
        onConfirm={duplicateOrder}
        onClose={() => setOpenCopyOrder(false)}
      />
      <DialogCustomerBlock
        onConfirm={toggleModalCustomerBlock}
        open={openModalCustomerBlock}
        okText="ปิดหน้าต่าง"
        title="Customer Blocked"
        // align={"center"}
        content={
          <>
            <img
              className={classes.iconModal}
              src={exclamationModal}
              alt="customer blocked"
            />
            <MyTypography variant="body2" className={classes.inlineBlock}>
              ไม่สามารถทำรายการได้ เนื่องจากลูกค้ารายนี้ถูก{" "}
              <MyTypography variant="subtitle2" className={classes.inlineBlock}>
                Block{" "}
              </MyTypography>
              กรุณาติดต่อเจ้าหน้าที่สินเชื่อ
            </MyTypography>
          </>
        }
      />
      <DialogCreditBlock
        onConfirm={toggleModalCreditBlock}
        open={openModalCreditBlock}
        okText="ปิดหน้าต่าง"
        title="Credit Blocked"
        content={
          <>
            <img
              className={classes.iconModal}
              src={exclamationModal}
              alt="customer blocked"
            />
            <MyTypography variant="body2" className={classes.inlineBlock}>
              ไม่สามารถทำรายการได้ เนื่องจากลูกค้าติด{" "}
              <MyTypography variant="subtitle2" className={classes.inlineBlock}>
                Credit Blocked{" "}
              </MyTypography>
              กรุณาติดต่อเจ้าหน้าที่สินเชื่อ
            </MyTypography>
          </>
        }
      />
    </Container>
  );
};

export default CreateOrChangeNotRefContractView;
